var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{class:['custom-btn', ("btn-" + _vm.type)],style:(_vm.buttonStyle),attrs:{"disabled":_vm.disabled},on:{"click":_vm.handleClick}},[_c('span',{staticClass:"btn-title"},[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),(_vm.subtitle)?_c('span',{staticClass:"btn-subtitle"},[_vm._v(_vm._s(_vm.subtitle))]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3ceafbcb","hasScoped":true,"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/BottomButton.vue
// module id = 235
// module chunks = 0